import sizesManifest from "@/lib/imageSizes.json";

/**
 * An <img> that serves the responsive WebP variants, carries its intrinsic dimensions and
 * loads lazily unless it is the page's leading image. Any source without generated variants
 * (logos, uploaded photographs) behaves exactly like a plain <img>.
 */
export const Img = ({ src, alt = "", sizes = "(max-width: 768px) 100vw, 800px",
                      priority = false, ...rest }) => {
  const meta = src ? sizesManifest[src] : null;
  const srcSet = meta?.sizes?.length
    ? [...meta.sizes.map((width) => `${src.replace(/\.webp$/, "")}-${width}.webp ${width}w`),
       `${src} ${meta.width}w`].join(", ")
    : undefined;
  return (
    <img
      src={src}
      alt={alt}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      width={meta?.width}
      height={meta?.height}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchPriority={priority ? "high" : undefined}
      {...rest}
    />
  );
};
